import { NoteTemplate } from '../../types';

export const noteTemplates: NoteTemplate[] = [
  {
    id: 'study-notes',
    name: 'Ders Notu',
    description: 'Ders çalışırken not almak için',
    category: 'study',
    content: `# Ders Notu

## Konu: 
**Tarih:** ${new Date().toLocaleDateString('tr-TR')}
**Ders:** 

---

## Ana Başlıklar
- 
- 
- 

## Detaylar

### 1. 


### 2. 


### 3. 


---

## Önemli Noktalar
> 

## Sorular
- [ ] 
- [ ] 
- [ ] 

## Özet
`,
    tags: ['ders', 'çalışma', 'not'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  },
  {
    id: 'exam-prep',
    name: 'Sınav Hazırlığı',
    description: 'Sınav hazırlığı için yapılacaklar listesi',
    category: 'exam',
    content: `# Sınav Hazırlığı

## Sınav Bilgileri
**Sınav:** 
**Tarih:** 
**Süre:** 
**Konu Alanları:** 

---

## Çalışma Planı

### Bu Hafta
- [ ] 
- [ ] 
- [ ] 

### Gelecek Hafta
- [ ] 
- [ ] 
- [ ] 

---

## Konu Başlıkları ve Durumu

| Konu | Durum | Notlar |
|------|-------|--------|
|      | ⭕ Başlanmadı / 🟡 Devam Ediyor / ✅ Tamamlandı |        |
|      |       |        |
|      |       |        |

---

## Zayıf Alanlar
- 
- 
- 

## Güçlü Alanlar
- 
- 
- 

## Son Tekrar Listesi
- [ ] 
- [ ] 
- [ ] 
`,
    tags: ['sınav', 'hazırlık', 'plan'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  },
  {
    id: 'formula-sheet',
    name: 'Formül Sayfası',
    description: 'Matematik ve fen formülleri için',
    category: 'study',
    content: `# Formül Sayfası

## Konu: 

---

## Temel Formüller

### 1. 
\`\`\`
Formül: 
Açıklama: 
Örnek: 
\`\`\`

### 2. 
\`\`\`
Formül: 
Açıklama: 
Örnek: 
\`\`\`

### 3. 
\`\`\`
Formül: 
Açıklama: 
Örnek: 
\`\`\`

---

## Önemli Notlar
> 

## Hatırlatmalar
- ⚠️ 
- ⚠️ 
- ⚠️ 

## Örnek Sorular
1. 

2. 

3. 
`,
    tags: ['formül', 'matematik', 'fen', 'referans'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  },
  {
    id: 'vocabulary',
    name: 'Kelime Listesi',
    description: 'İngilizce kelimeler ve anlamları',
    category: 'study',
    content: `# Kelime Listesi

## Konu/Ünite: 
**Tarih:** ${new Date().toLocaleDateString('tr-TR')}

---

## Yeni Kelimeler

| İngilizce | Türkçe | Örnek Cümle | Notlar |
|-----------|--------|-------------|--------|
|           |        |             |        |
|           |        |             |        |
|           |        |             |        |
|           |        |             |        |
|           |        |             |        |

---

## Deyimler (Idioms)
- **:** 
- **:** 
- **:** 

## Phrasal Verbs
- **:** 
- **:** 
- **:** 

---

## Tekrar Edilecekler
- [ ] 
- [ ] 
- [ ] 

## Zorlandığım Kelimeler
- 
- 
- 
`,
    tags: ['ingilizce', 'kelime', 'vocabulary'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  },
  {
    id: 'mind-map',
    name: 'Zihin Haritası',
    description: 'Konuları görsel olarak organize etmek için',
    category: 'study',
    content: `# Zihin Haritası

## Ana Konu: 

---

## Dallar

### 🌟 Ana Dal 1: 
- Alt konu 1.1
  - Detay 1.1.1
  - Detay 1.1.2
- Alt konu 1.2
  - Detay 1.2.1
  - Detay 1.2.2

### 🌟 Ana Dal 2: 
- Alt konu 2.1
  - Detay 2.1.1
  - Detay 2.1.2
- Alt konu 2.2
  - Detay 2.2.1
  - Detay 2.2.2

### 🌟 Ana Dal 3: 
- Alt konu 3.1
  - Detay 3.1.1
  - Detay 3.1.2
- Alt konu 3.2
  - Detay 3.2.1
  - Detay 3.2.2

---

## Bağlantılar
- Ana Dal 1 ↔ Ana Dal 2: 
- Ana Dal 2 ↔ Ana Dal 3: 
- Ana Dal 1 ↔ Ana Dal 3: 

## Anahtar Kelimeler
🔑 | 🔑 | 🔑 | 🔑 | 🔑

## Özet
`,
    tags: ['zihin-haritası', 'görsel', 'organize'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  },
  {
    id: 'quick-note',
    name: 'Hızlı Not',
    description: 'Kısa notlar ve fikirler için',
    category: 'general',
    content: `# Hızlı Not

**Tarih:** ${new Date().toLocaleDateString('tr-TR')}
**Saat:** ${new Date().toLocaleTimeString('tr-TR')}

---

## Not

## Etiketler
#

## Hatırlatma
- [ ] 
`,
    tags: ['hızlı', 'genel'],
    isPublic: true,
    usageCount: 0,
    createdBy: 'system',
    createdAt: new Date().toISOString()
  }
];

export default noteTemplates;